// Version : 1.0.0
// Author : AGALYA

const VoterIdDetailsActionType = {
	/** ***************** UPDATE VOTER ID START ************************/
	UPDATE_VOTER_ID_START: 'update_voter_id_start',
	UPDATE_VOTER_ID_SUCCESS: 'update_voter_id_success',
	UPDATE_VOTER_ID_FAILURE: 'update_voter_id_failure',
	UPDATE_VOTER_ID_RESPONSE_REST_START: 'update_voter_id_response_reset_start',
	UPDATE_VOTER_ID_RESPONSE_CHANGED: 'update_voter_id_response_changed',
	/** ***************** UPDATE VOTER ID END ************************/
};

export default VoterIdDetailsActionType;
